import React, { useState, useEffect } from "react";
import Page from "../../components/page/page";
import Header from "../../components/page/header";
import Footer from "../../components/page/footer";
import "./deviceStatus.css";
import { useLocation } from "react-router-dom";
import DataSheetImage from "../../assets/images/general/datasheet.svg";
import PlanImage from "../../assets/images/general/plan.svg";
import WorkingImage from "../../assets/images/general/working.svg";
import OilImage from "../../assets/images/general/oil.svg";
import { Link } from "react-router-dom";
import UserProfileService from "../../services/userProfileService";
import Auth from "../../services/authService";

let res;


const user = Auth.getCurrentUser();

function DeviceStatus() {

    const location = useLocation()
    const explodedDrawing = 3;

    useEffect(() => {
        (async () => {
            console.log("location.state.serial : ", location.state);
            res = await UserProfileService.getProductionOrderRunTime(user.customerid, location.state.serial);
            setLastWorkHour(res.data.LastVisitRunTime)
            setLastVisitDate(res.data.LastVisitDateShamsi)
            setNextVisitDate(res.data.NextVisitDateShamsi)
        })()
    }, []);

    const [lastWorkHour, setLastWorkHour] = useState("در حال بارگذاری");
    const [lastVisitDate, setLastVisitDate] = useState("در حال بارگذاری");
    const [nextVisitDate, setNextVisitDate] = useState("در حال بارگذاری");

    return (
        <Page>
            <Header />
            <section className="container">
                <div className="row devises_control">
                    <span className="top"></span>
                    <img className="img-fluid" src={`${location.state.imageUrl}`} alt="" />
                    <div className="Dinfo">
                        {location.state.serial !== null &&
                            <span>سریال: {location.state.serial}</span>
                        }
                        <h1 className="DeviceName">
                            {location.state.title}
                        </h1>
                        <br />
                        {location.state.codingTitle === "محصولات | کمپرسور Compressor " &&
                            <div>
                                <h6 className="DeviceType">آخرین ساعت کارکرد:  <span>{lastWorkHour}</span></h6>
                                <h6 className="DeviceType">تاریخ سرویس قبلی:  <span>{lastVisitDate}</span></h6>
                                <h6 className="DeviceType">تاریخ سرویس بعدی:  <span>{nextVisitDate}</span></h6>
                            </div>
                        }
                        {location.state.codingTitle === "محصولات | درایر Dryer" &&
                            <div>
                                <h6 className="DeviceType">آخرین ساعت کارکرد:  <span>{lastWorkHour}</span></h6>
                                <h6 className="DeviceType">تاریخ سرویس قبلی:  <span>{lastVisitDate}</span></h6>
                                <h6 className="DeviceType">تاریخ سرویس بعدی:  <span>{nextVisitDate}</span></h6>
                            </div>
                        }
                    </div>
                </div>
                <div className="row iotElement">
                    <div className="col text-center">
                        <img src={WorkingImage} alt="status" />
                        <h3>وضعیت فعلی دستگاه</h3>
                        <h5>روشن در حال کار</h5>
                    </div>
                    <div className="col text-center">
                        <img src={OilImage} alt="status" />
                        <h3>نیاز به سرویس</h3>
                        <h5>{nextVisitDate}</h5>
                    </div>
                </div>
            </section>

            {location.state.codingTitle === "محصولات | کمپرسور Compressor " &&
                <section className="container">
                    <div className="row hrow data-btn">
                        <Link to="/datasheet" state={{ title: location.state.title, productionCode: location.state.productionCode, codingTitle:location.state.codingTitle }} className="col ">
                            <div className="data-btn-item">
                                <img src={DataSheetImage} alt="دیتاشیت" />
                                <br />
                                <span className="imageDescription">دیتاشیت</span>
                            </div>
                        </Link>
                        <Link to={`/underConstruction/${explodedDrawing}`} className="col ">
                            <div className="data-btn-item">
                                <img src={PlanImage} alt="نقشه انفجاری" />
                                <br />
                                <span className="imageDescription">نقشه انفجاری</span>
                            </div>
                        </Link>
                    </div>
                </section>
            }
            {location.state.codingTitle === "محصولات | درایر Dryer" &&
                <section className="container">
                    <div className="row hrow data-btn">
                        <Link to="/datasheet" state={{ title: location.state.title, productionCode: location.state.productionCode, codingTitle: location.state.codingTitle }} className="col ">
                            <div className="data-btn-item">
                                <img src={DataSheetImage} alt="دیتاشیت" />
                                <br />
                                <span className="imageDescription">دیتاشیت</span>
                            </div>
                        </Link>
                        <Link to={`/underConstruction/${explodedDrawing}`} className="col ">
                            <div className="data-btn-item">
                                <img src={PlanImage} alt="نقشه انفجاری" />
                                <br />
                                <span className="imageDescription">نقشه انفجاری</span>
                            </div>
                        </Link>
                    </div>
                </section>
            }
            {location.state.codingTitle === "محصولات | ژنراتور اکسیژن O2 Generator" &&
                <section className="container">
                    <div className="row hrow data-btn">
                        <Link to="/datasheet" state={{ title: location.state.title, productionCode: location.state.productionCode, codingTitle: location.state.codingTitle }} className="col ">
                            <div className="data-btn-item">
                                <img src={DataSheetImage} alt="دیتاشیت" />
                                <br />
                                <span className="imageDescription">دیتاشیت</span>
                            </div>
                        </Link>
                        <Link to={`/underConstruction/${explodedDrawing}`} className="col ">
                            <div className="data-btn-item">
                                <img src={PlanImage} alt="نقشه انفجاری" />
                                <br />
                                <span className="imageDescription">نقشه انفجاری</span>
                            </div>
                        </Link>
                    </div>
                </section>
            }
            <section className="container">
                <div className="row hrow mt-4">
                    <Link className="btn btn-dark" to="/ServiceRequest">
                        درخواست خدمات
                    </Link>
                </div>
                <br />
                <div className="row hrow">
                    <Link className="btn btn-dark" to="/visitHistoryBySerial" state={{ serial: location.state.serial }}>
                        درخواست های پشتیبانی قبلی
                    </Link>
                </div>
            </section>
            <Footer />
        </Page>
    );
}

export default DeviceStatus